// Hook odpowiedzialny za aktualizację reklamacji / zamówienia

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

const requestKeys = [
  'order_position_id',
  'return_complain_type_id',
  'return_complain_reason_id',
  'description',
  'user_notes',
  'custom_symbol'
];

// parametry requestu do api
interface IRequest {
  order_position_id?: number;
  return_complain_type_id?: number;
  return_complain_reason_id?: number;
  description?: string;
  user_notes?: string;
  custom_symbol?: string;
}

// typ zwracanych danych
type IResponse = ICommandResponseSuccess;

const putReturnComplaint = (returnComplainId: number, data: IRequest): Promise<IResponse> =>
  axios.put(`/return-complain/${returnComplainId}`, data, {
    env: { FormData: { requestKeys: requestKeys } as any }
  });

export const usePutReturnComplaint = (
  returnComplainId: number,
  options?: UseMutationOptions<IResponse, IError, IRequest>
) => useMutation((data: IRequest) => putReturnComplaint(returnComplainId, data), options);
